import { render, staticRenderFns } from "./DispatcherReportCardHeader.vue?vue&type=template&id=640ac012&scoped=true&"
import script from "./DispatcherReportCardHeader.vue?vue&type=script&lang=js&"
export * from "./DispatcherReportCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./DispatcherReportCardHeader.vue?vue&type=style&index=0&id=640ac012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ac012",
  null
  
)

export default component.exports